module.exports = __webpack_public_path__ + "img/border2.73cd5868.png";